/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor(private zone: NgZone) {}
  localStorageUpdate$ = new BehaviorSubject<string>('');

  updateStorage(key: string, value: any) {
    this.zone.runOutsideAngular(() => {
      localStorage.setItem(key, JSON.stringify(value));
    });

    this.localStorageUpdate$.next(key);
  }

  getStorage(key: string): any {
    const value = localStorage.getItem(key);
    return value && JSON.parse(value);
  }

  updateDispatchLocalStorage(key: string, newValue: any) {
    const oldValue = localStorage.getItem(key);
    localStorage.setItem(key, JSON.stringify(newValue));

    const storageEvent = new StorageEvent('storage', {
      key: key,
      oldValue: oldValue,
      newValue: JSON.stringify(newValue),
    });

    window.dispatchEvent(storageEvent);
  }
}
